var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './DefaultHeaderView.html';
import './defaultHeader.scss';
import { TenantService } from 'modules/application/tenant/TenantService';
let DefaultHeaderComponent = class DefaultHeaderComponent {
    static $inject = ['TenantService'];
    constructor(TenantService) {
        this.TenantService = TenantService;
        this.upgradeSubscriptionIsEnabled = false;
    }
    $onInit() {
        this.checkFeatures();
    }
    async checkFeatures() {
        this.isOrganizationEnabled = await this.TenantService.isOrganizationEnabled();
    }
};
DefaultHeaderComponent.$inject = ['TenantService'];
DefaultHeaderComponent = __decorate([
    Component({
        template,
        bindings: {
            useSpecialHeader: '<',
            userAccountType: '@',
            user: '<',
            menus: '<',
            onMenuOpen: '&',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof TenantService !== "undefined" && TenantService) === "function" ? _a : Object])
], DefaultHeaderComponent);
export { DefaultHeaderComponent };
